import React from 'react';
import classNames from 'classnames';
import { components } from 'react-select';
const ReactSelectControl = components.Control;

const Control = (props) => {
  const {
    selectProps: { invalid, isTouchDevice, iconComponent, prefixTextComponent },
  } = props;
  const { children, ...restProps } = props;
  const classes = classNames({
    'ws-ui-base-select__control--is-invalid': invalid,
    'ws-ui-base-select__control--is-touch-device': isTouchDevice,
  });

  return (
    <ReactSelectControl className={classes} {...restProps}>
      {iconComponent}
      {prefixTextComponent}
      {children}
    </ReactSelectControl>
  );
};

export default Control;
